export function Billing(): JSX.Element {
  return (
    <article>
      <h1 className="text-[28px] font-semibold text-ink mb-2">计费说明</h1>
      <p className="text-ink-muted mb-10">
        哪都通采用按量计费模式。用多少扣多少，没有套餐、没有最低消费。
      </p>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">计费原理</h2>
        <div className="space-y-3 text-[14px] text-ink-muted">
          <p>
            每次 API 调用完成后，系统根据实际消耗的 Token 数量实时扣费。
          </p>
          <div className="rounded-xl bg-butter/40 px-5 py-4 text-[14px] text-ink space-y-3">
            <div className="font-mono text-center">
              你的单价 = 官方价(CNY) × 渠道折扣
            </div>
            <div className="font-mono text-center text-ink-muted text-[13px]">
              官方价(CNY) = 厂商美元价 × 平台汇率
            </div>
          </div>
          <p>
            例如 Claude Opus 4.7 输入官方价 $5/MTok，平台汇率 7，官方价(CNY) = ¥35/MTok。
            如果你选择的渠道是 1.2 折，那么你的实际输入单价 = ¥35 × 0.12 = ¥4.20/MTok。
          </p>
          <ul className="space-y-2 mt-4">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong>官方价</strong>：模型厂商的定价（USD/百万 Token），乘以平台汇率转为 CNY</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong>渠道折扣</strong>：不同渠道有不同的折扣。1.2 折 = 官方价的 12%，2.5 折 = 25%，折扣越低越便宜</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span><strong>平台汇率</strong>：由运营统一设定的 USD→CNY 汇率，定期调整</span>
            </li>
          </ul>
          <p className="mt-3">
            各渠道的具体折扣和价格请查看 <a href="#pricing" className="text-claude hover:underline">首页定价表</a>。
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">余额与充值</h2>
        <div className="space-y-3 text-[14px] text-ink-muted">
          <p>
            账户余额以人民币计价。注册时赠送少量体验余额，正式使用前需要充值。
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>在控制台「余额」页面完成充值</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>当前支持微信支付充值</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>充值即时到账，无等待时间</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>余额不足时 API 请求会被拒绝（HTTP 402），不会产生欠费</span>
            </li>
          </ul>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">渠道与定价</h2>
        <div className="space-y-3 text-[14px] text-ink-muted">
          <p>
            创建 API Key 时选择渠道。每个渠道是一条独立的模型供应路线，有独立的折扣力度。同一个模型在不同渠道的价格可能差异很大。
          </p>
          <p>
            折扣含义：1.2 折表示你只需支付官方 CNY 价格的 12%。折扣越小越便宜。
          </p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-[20px] font-semibold text-ink mb-4">用量查询</h2>
        <div className="space-y-3 text-[14px] text-ink-muted">
          <p>
            在控制台「用量」页面可以查看每日 API 调用明细，包括每次请求的模型、Token 数量和扣费金额。数据每小时自动汇总。
          </p>
        </div>
      </section>
    </article>
  );
}
